<template>
  <div>
    <div class="addExperiment-title">
      <span @click="goRouter('/college')"
        >学院管理&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <i>学生管理</i>
    </div>
    <div style="background: #fff; padding: 20px">
      <h1 class="header">
        <span>新增/编辑学生</span>
        <el-button @click="goRouter('/studentManage')" class="fr">返回</el-button>
      </h1>
      <!-- <div class="simple-tabs">
      <span
        v-for="tab in tabs"
        :key="tab.id"
        :class="activeTab===tab.id?'active':''"
        @click="activeTab=tab.id"
      >{{tab.name}}</span>
    </div> -->
      <div v-show="activeTab === 1">
        <!-- <div style="margin:10px 0;">

        <el-button type="primary" @click="userVisible = true">选择已有账号</el-button>
      </div> -->
        <el-form
          ref="formValidate"
          :model="form"
          label-width="100px"
          :rules="rule"
        >
          <!-- <Form ref="edit" :model="form" :rules="rule" :label-width="80"> -->
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户ID" prop="userId">
                <el-input v-model="form.userId" disabled style="width: 200px" />
              </el-form-item>
              <el-form-item label="真实姓名" prop="studentName">
                <el-input
                  v-model="form.studentName"
                  style="width: 200px"
                  placeholder="请输入真实姓名"
                />
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input
                  v-model="form.mobile"
                  style="width: 200px"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item label="邮箱号" prop="email">
                <el-input
                  v-model="form.email"
                  style="width: 200px"
                  placeholder="请输入邮箱号"
                />
              </el-form-item>
              <el-form-item label="毕业年份" prop="graduationYear">
                <el-input v-model="form.graduationYear" style="width: 200px" />
              </el-form-item>
              <el-form-item label="学历" prop="education">
                <el-select v-model="form.education" style="width: 200px">
                  <el-option :value="1" label="高中及以下"></el-option>
                  <el-option :value="2" label="大专"></el-option>
                  <el-option :value="3" label="本科"></el-option>
                  <el-option :value="4" label="硕士"></el-option>
                  <el-option :value="5" label="博士"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="form.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学号" prop="licenseNo">
                <el-input v-model="form.licenseNo" style="width: 200px" />
              </el-form-item>
              <el-form-item label="高校" prop="schoolId">
                <el-select
                  v-model="form.schoolId"
                  @input="getSchoolChange(form.schoolId, 'reset')"
                  disabled
                >
                  <el-option
                    v-for="item in schoolData"
                    :key="item.schoolId"
                    :value="item.schoolId"
                    :label="item.schoolName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="学院" prop="collegeId">
                <el-select
                  v-model="form.collegeId"
                  @input="collegeChange(form.collegeId, 'reset')"
                >
                  <el-option
                    v-for="item in collegeData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="专业" prop="majorId">
                <el-select
                  v-model="form.majorId"
                  @input="majorChange(form.majorId, 'reset')"
                >
                  <el-option
                    v-for="item in majorData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="年级" prop="gradeId">
                <el-select
                  v-model="form.gradeId"
                  @input="gradeChange(form.gradeId, 'reset')"
                >
                  <el-option
                    v-for="item in gradeData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级" prop="classId">
                <el-select v-model="form.classId">
                  <el-option
                    v-for="item in classData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="form.remark" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" @click="saveSubmit('formValidate')"
              >保存</el-button
            >
            <el-button @click="userVisible = true">选择已有账号</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="activeTab === 2">
        <el-button>查看样例文件</el-button>
        <el-button>上传文件</el-button>
        <el-button type="primary">开始生成</el-button>
      </div>

      <el-dialog
        title="选择已有账号"
        :visible.sync="userVisible"
        :close-on-press-escape="false"
        top="2vh"
        :close-on-click-modal="false"
        width="800px"
      >
        <user @getConsultant="getSelect"></user>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import user from "@/components/dialog/userRadio.vue";
export default {
  data() {
    return {
      userVisible: false,
      // 学院参数
      paramCollege: {
        showItem: 1000,
        schoolId: this.$route.query.schoolId,
        pageIndex: 1,
        word: "",
      },
      paramMajor: {
        collegeId: 0,
        schoolId: this.$route.query.schoolId,
      }, // 获取专业参数
      classData: [], // 班级
      gradeData: [], // 年级
      majorData: [], // 专业
      schoolData: [],
      collegeData: [], // 学院
      activeTab: 1,
      tabs: [
        {
          id: 1,
          name: "新建学生",
        },
        // {
        //   id: 2,
        //   name: "导入excel"
        // }
      ],
      id: this.$route.query.id,
      form: {
        classId: null, // 班级
        collegeId: null, // 学院id
        education: null, // 学历
        email: "", // 邮箱
        gradeId: null, // 年级
        graduationYear: "", // 毕业年份
        licenseNo: "", // 学号id
        majorId: null, // 专业id
        mobile: "", // 手机号
        schoolId: Number(this.$route.query.schoolId), // 高校id
        sex: 1, // 性别
        studentId: 0, // 数据库自增id
        studentName: "", // 真实姓名
        userId: 0, // 点宽用户id，用于绑定, 如果为空说明需要创建
        remark: "", // 备注
      },
      rule: {
        classId: [
          { required: true, message: "班级名称不能为空", trigger: "blur" },
        ],
        collegeId: [
          {
            type: "number",
            required: true,
            message: "请选择学院",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            pattern:
              /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
            message: "邮箱格式不正确",
            trigger: "blur",
          },
        ],
        gradeId: [
          { required: true, message: "年级不能为空", trigger: "change" },
        ],
        graduationYear: [
          { required: true, message: "毕业年份不能为空", trigger: "change" },
        ],
        licenseNo: [
          { required: true, message: "学号不能为空", trigger: "change" },
        ],
        majorId: [{ required: true, message: "专业不能为空", trigger: "blur" }],
        mobile: [
          // { required: true, message: "手机号不能为空", trigger: "blur" }
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            required: true,
            pattern:
              /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        schoolId: [
          { required: true, message: "高校不能为空", trigger: "blur" },
        ],
        sex: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        studentName: [
          { required: true, message: "真实姓名不能为空", trigger: "blur" },
        ],
      },
      specialtyList: [],
    };
  },
  components: { user },
  methods: {
    // 手机正则
    validatorPhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      }
    },
    // 邮箱正则
    sendEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error("邮箱不能为空"));
      } else if (
        !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          value
        )
      ) {
        callback(new Error("邮箱格式不正确"));
      }
    },
    // 获取用户账号
    getSelect(res) {
      this.form.studentName = res.realName || res.userName; // 真实姓名
      this.form.mobile = res.phoneNumber; // 手机号码
      this.form.email = res.email; // 邮箱
      this.form.userId = res.userId;
      this.userVisible = false;
    },
    ngOnInit() {
      // 获取学院列表
      const paramSchool = {
        word: "",
      };
      // 高校select
      this.$api.allianceSchool.getSchoolList(paramSchool).then((res) => {
        if (res.errCode == 0) {
          this.schoolData = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      });
      if (this.$route.query.studentId) {
        const param = {
          schoolId: this.$route.query.schoolId,
          studentId: this.$route.query.studentId,
        };
        this.getStudentInfo(param);
      }
    },
    getStudentInfo(param) {
      // 编辑获取学生信息
      const than = this;
      this.$api.allianceSchool.getStudentInfo(param).then((res) => {
        if (res.errCode == 0) {
          than.form = res.data;
          if (res.data.schoolId) {
            // 获取学院
            than.getSchoolChange(res.data.schoolId);
          }
          if (res.data.majorId) {
            // 获取专业
            than.collegeChange(res.data.collegeId);
          }
          if (res.data.gradeId) {
            // 获取年级
            than.majorChange(res.data.majorId);
          }
          if (res.data.classId) {
            // 获取班级
            than.gradeChange(res.data.gradeId);
          }
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 高校下拉框获取学院select
    getSchoolChange(itemID, type) {
      this.paramCollege.schoolId = itemID;
      this.$api.allianceSchool.getCollegeList(this.paramCollege).then((res) => {
        if (res.errCode == 0) {
          this.collegeData = res.data.items;
          if (type == "reset") {
            // 学院
            this.form.collegeId = null;
            // 专业
            this.form.majorId = null;
            this.majorData = [];
            // 年级
            this.form.gradeId = null;
            this.gradeData = [];
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 学院获取专业下拉框
    collegeChange(res, type) {
      this.paramMajor.collegeId = res;
      this.$api.allianceSchool.getMajorList(this.paramMajor).then((item) => {
        if (item.errCode == 0) {
          this.majorData = item.data;
          if (type == "reset") {
            // 专业
            this.form.majorId = null;
            // 年级
            this.form.gradeId = null;
            this.gradeData = [];
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 专业获取年级下拉框
    majorChange(res, type) {
      const param = {
        majorId: res,
        schoolId: this.paramCollege.schoolId,
      };
      this.$api.allianceSchool.getGradeList(param).then((item) => {
        if (item.errCode == 0) {
          this.gradeData = item.data;
          if (type == "reset") {
            // 年级
            this.form.gradeId = null;
            // 班级
            this.form.classId = null;
            this.classData = [];
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 获取班级
    gradeChange(res, type) {
      const param = {
        gradeId: res,
        schoolId: this.paramCollege.schoolId,
      };
      this.$api.allianceSchool.collegeMgrGetClassList(param).then((item) => {
        if (item.errCode == 0) {
          this.classData = item.data;
          if (type == "reset") {
            // 班级
            this.form.classId = null;
          }
        } else {
          this.$message.error(item.errMsg);
        }
      });
    },
    // 获取专业下年级列表
    toListPage() {
      this.$router.push({
      });
    },
    // 保存
    saveSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.allianceSchool.updateStudent(this.form).then((item) => {
            if (item.errCode == 0) {
              // this.$router.push({
              //   path: "/alliance/student",
              //   query: {
              //     schoolId: this.paramCollege.schoolId,
              //   },
              // });
               this.$message.success("提交成功!");
              this.$router.go(-1);
            } else {
              this.$message.error(item.errMsg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goRouter(path) {
      this.$router.push(path);
    },
  },
  created() {
    this.ngOnInit();
    this.getSchoolChange(this.paramCollege.schoolId);
  },
};
</script>

<style lang="less" scoped>

.header {
  font-size: 16px;
  font-family: PingFang-SC;
}
.addExperiment-title {
  margin-bottom: 16px;
  span,
  i {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    opacity: 1;
    font-style: normal;
  }
  span {
    color: #939393;
    cursor: pointer;
  }
}
</style>